import { render, staticRenderFns } from "./PlanThree.vue?vue&type=template&id=5fdc033f&scoped=true&"
import script from "./PlanThree.vue?vue&type=script&lang=js&"
export * from "./PlanThree.vue?vue&type=script&lang=js&"
import style0 from "./PlanThree.vue?vue&type=style&index=0&id=5fdc033f&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fdc033f",
  null
  
)

export default component.exports